import React, { useEffect, useState } from "react";
import Input from "../../../../components/form/Input";
import SelectSingleImage from "../../../../components/form/SelectSingleImage";
import Button from "../../../../components/form/Button";
import useForm from "../../../../hooks/useForm";
import Textarea from "../../../../components/form/Textarea";
import { organizationAddEdit, organizationDetails } from "../../../../services/organizationService";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import RoundedImageUpload from "../../../../components/form/RoundedImageUpload";
import { useSelector } from "react-redux";
import { useBistroNavigation } from "../../../../hooks/useBistroNavigation";
import { toast } from "react-toastify";

const validation = {
  name: { required: true, message: "Name title is required" },
  slug: { required: true, message: "Slug is required" },
};

const Settings = () => {
  const [logo, setLogo] = useState("");
  const { getPath, config } = useBistroNavigation();
  const queryClient = useQueryClient();

  const { values, handleChange, handleSubmit, errors, setFieldsValue, formValidate } = useForm({
    validationRules: validation,
  });

  const { data: details } = useQuery({
    queryKey: ["organization-details", config?._id],
    queryFn: async () => {
      const res = await organizationDetails({ id: config?._id });
      return res?.data;
    },
    enabled: !!config?._id,
  });

  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        name: details?.name || "",
        slug: details?.slug || "",
        website: details?.website || "",
      });

      setLogo(details?.logo || null);
    }
  }, [details?._id]);

  const { mutate, isPending } = useMutation({
    mutationFn: async (formData) => {
      const payload = {
        ...formData,
        id: config?._id,
        type: "organizer",
        logo:logo?.file
      };

      return await organizationAddEdit(payload);
    },

    onSuccess: (res) => {
      toast.success("Settings updated successfully!");
      queryClient.invalidateQueries(["organization-details", config?._id]);
    },

    onError: () => {
      toast.error("Failed to update settings!");
    },
  });

  const submitForm = () => {
    mutate(values);
  };

  return (
    <form onSubmit={(event) => handleSubmit(event, submitForm)} className="p-4 w-full space-y-10 min-h-screen">
      <div className="flex justify-between">
        <div className="text-3xl font-bold text-primary tracking-tight">Settings</div>
        <Button
          buttonLabel="Save"
          buttonType="submit"
          buttonIcon="fa-regular fa-floppy-disk"
          buttonClasses="
            min-w-[120px] py-2 rounded-lg text-xl font-semibold
            shadow-md hover:shadow-xl transition-all
            bg-black hover:bg-primary text-white hover:scale-[1.02]
          "
        />
      </div>

      <div
        className="
        rounded-[20px] p-10 bg-white/70 backdrop-blur-xl 
        shadow-[0_8px_30px_rgb(0,0,0,0.06)]
        hover:shadow-[0_12px_40px_rgb(0,0,0,0.10)]
        transition-all duration-300 space-y-6 border border-white/60
      "
      >
        <h3 className="text-xl font-semibold text-primary">Logo</h3>

        <div className="flex items-center gap-10">
          <RoundedImageUpload value={logo} onChange={(img) => setLogo(img)} />

          <p className="text-gray-600 text-sm leading-relaxed max-w-md">
            Provide a high-resolution, rounded version of your restaurant’s logo. It will be used across the whole system for consistent branding.
          </p>
        </div>
      </div>

      <div
        className="
        rounded-[20px] p-10 bg-white/70 backdrop-blur-xl 
        shadow-[0_8px_30px_rgb(0,0,0,0.06)]
        hover:shadow-[0_12px_40px_rgb(0,0,0,0.10)]
        transition-all duration-300 space-y-6 border border-white/60
      "
      >
        <h3 className="text-xl font-semibold text-primary">Information</h3>
        <div className="grid grid-cols-2 gap-6">
          <Input
            label="Name"
            inputPlaceholder="Enter site title"
            inputName="name"
            value={values?.name}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />

          <Input
            label="Code"
            inputPlaceholder="Enter code"
            inputName="slug"
            value={values?.slug}
            onChange={handleChange}
            {...formValidate(errors, "slug")}
          />
        </div>
        <Input
          label="Address"
          inputPlaceholder="Enter address..."
          inputName="website"
          value={values?.website}
          onChange={handleChange}
          // {...formValidate(errors, "slug")}
        />
      </div>
    </form>
  );
};

export default Settings;
